var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "leftarrowIcon",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 47.255 47.255",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "arrow",
    d: "M23.6272.0008a1,1,0,0,1,.707,1.707l-21.92,21.92,21.92,21.92a1,1,0,1,1-1.414,1.414L.2932,24.3358a.9991.9991,0,0,1,0-1.414L22.92.2937A.9989.9989,0,0,1,23.6272.0008Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "line",
    d: "M1.0088,22.6278H46.2462a1,1,0,1,1,0,2H1.0088a1,1,0,1,1,0-2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftarrow);
export default __webpack_public_path__ + "static/media/leftarrow.151fc79e.svg";
export { ForwardRef as ReactComponent };